// extracted by mini-css-extract-plugin
export default {"Dashboard":"Dashboard_Dashboard__mIk-R","Home":"Dashboard_Home__K+CYt","container":"Dashboard_container__gNKVC"};